import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  'https://nxplykkdmumsfbuklpse.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im54cGx5a2tkbXVtc2ZidWtscHNlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI0OTcwNDUsImV4cCI6MjA5ODA3MzA0NX0.ljoI91d36A8m0hjjAVnFnq8Sv30dpyq6efsx5cgAelo'
);
